import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=1ff8d272&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=js&"
export * from "./ViewForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewForm.vue?vue&type=style&index=1&id=1ff8d272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8d272",
  null
  
)

export default component.exports